/**
 * @file calendar.tsx
 * @description Календарь кабинета — обёртка над `react-day-picker` (shadcn
 * calendar; phase19.31, общее поле даты `DateField`).
 *
 * Русская локаль, неделя с понедельника, выбор месяца и года списками
 * (сроки годности бывают на годы вперёд). Цвета — токены темы: выбранный
 * день цветом действия, сегодня — подчёркнут; размер дня — цель касания не
 * меньше 40px.
 *
 * phase19.31 (дефект приёмки 2026-10-02: стрелки месяцев и списки месяца/года
 * синие по умолчанию, не цвет темы): `react-day-picker/style.css` подключён
 * вне слоёв и объявляет `--rdp-accent-color: blue` на `.rdp-root` — классы
 * Tailwind (они в слое) ему проигрывали. Поэтому переменные палитры задаём
 * через `style` (встроенный стиль сильнее любого правила), а значок стрелок —
 * через `styles.chevron`: стрелки и списки — вторым цветом текста темы,
 * выбранный день — цветом действия.
 */

import type { ComponentProps, CSSProperties } from "react";
import { DayPicker } from "react-day-picker";
import { ru } from "react-day-picker/locale";
import "react-day-picker/style.css";

import { cn } from "@/lib/utils";

type Props = ComponentProps<typeof DayPicker>;

/** Палитра календаря из токенов темы (см. шапку файла — почему `style`). */
const THEME_VARS = {
  "--rdp-accent-color": "var(--primary)",
  "--rdp-accent-background-color": "var(--accent)",
  "--rdp-today-color": "var(--primary)",
  "--rdp-day-height": "2.5rem",
  "--rdp-day-width": "2.5rem",
  "--rdp-day_button-height": "2.5rem",
  "--rdp-day_button-width": "2.5rem",
} as CSSProperties;

/** Стрелки месяцев и значок списков — второй цвет текста, не «акцент». */
const CHEVRON_STYLE: CSSProperties = { fill: "var(--on-surface-variant)" };

export function Calendar({ className, style, styles, ...props }: Props) {
  return (
    <DayPicker
      locale={ru}
      weekStartsOn={1}
      captionLayout="dropdown"
      startMonth={new Date(2000, 0)}
      endMonth={new Date(new Date().getFullYear() + 15, 11)}
      className={cn("text-on-surface", className)}
      style={{ ...THEME_VARS, ...style }}
      styles={{ ...styles, chevron: { ...CHEVRON_STYLE, ...styles?.chevron } }}
      {...props}
    />
  );
}
